<template>
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M4 8h8" />
    </svg>
</template>

<script lang="ts" setup vapor>
defineOptions({ name: 'MinusIcon' });
</script>
